/* Mobile Nav Toggle — portiert aus Header.astro (V3 Sand & Stone).
   Hamburger ↔ Panel, Escape schließt, Viewport-Switch zu Desktop schließt. */
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var panel = document.querySelector('[data-mobile-nav]');
  if (!toggle || !panel) return;

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    setOpen(!isOpen);
  });

  if (window.matchMedia) {
    var mq = window.matchMedia('(min-width: 768px)');
    mq.addEventListener('change', function (e) {
      if (e.matches) setOpen(false);
    });
  }

  Array.prototype.forEach.call(panel.querySelectorAll('a'), function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      setOpen(false);
      toggle.focus();
    }
  });
})();

/* Sprache beibehalten: Auf /en-Seiten bekommen interne Seiten- und Collection-Links
   das /en-Praefix, damit man beim Wechsel der Seiten in der gewaehlten Sprache bleibt.
   Die Sprachumschalter-Buttons (DE/EN) werden bewusst ausgelassen, damit der
   Sprachwechsel weiter funktioniert. */
(function () {
  var path = window.location.pathname;
  if (path !== '/en' && path.indexOf('/en/') !== 0) return;
  var links = document.querySelectorAll('a[href^="/pages/"], a[href^="/collections/"]');
  Array.prototype.forEach.call(links, function (a) {
    if (a.classList.contains('site-lang-switch__btn')) return;
    var h = a.getAttribute('href');
    if (h && h.indexOf('/en/') !== 0) {
      a.setAttribute('href', '/en' + h);
    }
  });
})();
